import { FilterAltOff, LineWeight, SwapVert } from "@mui/icons-material";
import { Box, Button, CircularProgress, Grid, LinearProgress, Paper, Tooltip, Typography } from "@mui/material/";
import { cloneDeep } from "lodash";
import { useContext, useEffect, useState } from "react";
import { SearchContext } from "../../contexts/SearchContext";
import { IMaterialGroup } from "../../interfaces";
import { MaterialImportDialog } from "../MaterialImportDialog";
import { SearchResult } from "../SearchResult";
import { SearchResultHeaderRow } from "../SearchResult/HeaderRow";
import { SearchPrompt } from "../SearchResult/SearchPrompt";
import { AdvancedSearchWidget } from "./AdvancedSearchWidget";
import { AuditWidget } from "./AuditWidget";
import { ContractWidget } from './ContractWidget';
import { DispatchRequestWidget } from "./DispatchRequestWidget";
import { RecentSearchWidget } from "./RecentSearchWidget";
import { ResultOptionsWidget } from "./ResultOptionsWidget";
import { StorageRequestWidget } from './StorageRequestWidget';

export const Dashboard: React.FC = () => {

    const search = useContext(SearchContext);

    const canClearFilter = () => {
        if (search.resultOptions.filter(x => (x.filteredValues && x.filteredValues.length > 0)).length === 0)
            return false;

        return true;
    }

    const anyResults = () => {
        if (!search.results || search.results.length === 0)
            return false;

        return true;
    }

    const getResults = () => {
        if (reverseOrder)
            return cloneDeep(searchResults).reverse();

        return searchResults;
    }

    const [searchResults, setSearchResults] = useState<IMaterialGroup[]>([]);
    const [reverseOrder, setReverseOrder] = useState<boolean>(false);
    const [showHeadings, setShowHeadings] = useState(true);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(25);

    useEffect(() => {
        if (page > 1)
            search.search(undefined, undefined, page);
    }, [page])

    useEffect(() => {

        console.log("search results ", search.results?.length);

        if (search.results) {
            if (searchResults !== search.results) {
                setSearchResults(search.results);
            }
        }
        else setSearchResults([]);

    }, [search.results, search.searching])// eslint-disable-line react-hooks/exhaustive-deps


    return (<div>


        {(search.query.length > 0 || search.keywords.length > 0 || search.results || search.searching) ?
            <Grid container spacing={2}>
                <Grid item xs={3} style={{ marginBottom: '10em' }}>
                    <RecentSearchWidget />
                    <ResultOptionsWidget />
                    <AdvancedSearchWidget />
                </Grid>
                <Grid item xs={9}>
                    {anyResults() &&
                        <Box display="flex" justifyContent="space-between">
                            <div>
                                <Tooltip title={"turn compact view " + (showHeadings ? "on" : "off")}>
                                    <Button sx={{ mb: 1, mr: 1, pl: 1, pr: 1, minWidth: "10px" }} variant={showHeadings ? "outlined" : "contained"} size="small" onClick={() => setShowHeadings(!showHeadings)} >
                                        <LineWeight />
                                    </Button>
                                </Tooltip>

                                {canClearFilter() &&
                                    <Button
                                        sx={{ mb: 1, mr: 1 }}
                                        variant="outlined"
                                        size="small"
                                        onClick={search.clearFilters}
                                    >
                                        <FilterAltOff /> Clear filters
                                    </Button>
                                }

                                <Tooltip title={"change order to " + (reverseOrder ? "Ascending" : "Descending")}>
                                    <Button sx={{ mb: 1 }} variant="outlined" size="small" onClick={() => setReverseOrder(!reverseOrder)} ><SwapVert /> {reverseOrder ? "Descending" : "Ascending"}</Button>
                                </Tooltip>
                            </div>
                            <div>
                                {search.exportingSearch ?
                                    <><Button sx={{ mb: 1, mr: 1 }} variant="outlined" size="small" disabled ><small>Preparing - please wait</small><CircularProgress sx={{ ml: 2, opacity: .5 }} size="1rem" /></Button> </> : <>
                                        <Button sx={{ mb: 1, mr: 1 }} variant="outlined" size="small" onClick={() => search.exportResults()} >Export</Button>

                                        <MaterialImportDialog
                                            onImported={() => search.search()}
                                        />


                                        <Button sx={{ mb: 1, mr: 1 }} variant="outlined" size="small" color="warning" onClick={() => search.auditResults()} >Audit</Button>
                                    </>
                                }
                            </div>
                        </Box>
                    }

                    {anyResults() && !showHeadings && <SearchResultHeaderRow />}

                    {getResults().map((x, i) => {
                        if (i < (page * pageSize)) {
                            return (
                                <SearchResult
                                    key={x.id + i.toString()}
                                    materialGroup={x}
                                    showHeaderLabels={showHeadings}
                                />
                            );
                        }
                    })}


                    <Box textAlign="center" sx={{ mt: 4, mb: 6 }}>

                        {  getResults().length > (page * pageSize) ? <>
                                <Typography variant="subtitle2">Showing {page * pageSize} results</Typography>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={() => setPage(page + 1)}
                                >Show More</Button>
                                {page > 1 &&
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        color="info"

                                        onClick={() => setPage(page - 1)}
                                        sx={{ ml: 1 }}
                                    >Less</Button>
                                }
                            </> : <Typography variant="subtitle2">Showing {getResults().length} results</Typography>
                        }

                    </Box>


                    {searchResults.length === 0 && <SearchPrompt searching={search.searching} />}

                </Grid>

            </Grid>
            :
            <Grid container spacing={2} sx={{ height: 'calc(100vh - 9em)' }}>
                <Grid item xs={4} sx={{ height: '100%', boxSizing: 'border-box' }}>
                    <RecentSearchWidget expanded />
                </Grid>
                <Grid container spacing={2} item xs={8}>
                    <Grid item xs={6}>
                        <StorageRequestWidget />
                    </Grid>
                    <Grid item xs={6}>
                        <ContractWidget />
                    </Grid>
                    <Grid item xs={6}>
                        <AuditWidget />
                    </Grid>
                    <Grid item xs={6}>
                        <DispatchRequestWidget />
                    </Grid>
                </Grid>
            </Grid>
        }
    </div >);
}